import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLoading,
} from '@ionic/react'
import { format, parseISO } from 'date-fns'

import { Card, CardContent } from '../../../components/ui/card'
import { useInfiniteData } from '../../../hooks/use-infinite-data'
import { useRedeemedRewards } from '../../../loyalty/queries'

function CashierRedeemedRewardsDetail() {
  const redeemedRewards = useRedeemedRewards()

  const [ionInfiniteScrollRef, loadMore] = useInfiniteData(
    redeemedRewards.fetchNextPage
  )

  if (redeemedRewards.data) {
    const flatRewards = redeemedRewards.data.pages.flatMap((d) => d.data)

    return flatRewards.length ? (
      <div className="space-y-2 py-4">
        {flatRewards.map((reward) => (
          <Card key={reward.objectId}>
            <CardContent>
              <div className="flex flex-1 flex-col">
                <span className="text-lg font-semibold">{reward.text}</span>
                <span className="text-lg">{reward.points} Points</span>
                {reward.redeemedAt ? (
                  <span className="text-sm text-slate-600">
                    Redeemed on{' '}
                    {format(parseISO(reward.redeemedAt.iso), 'MMM do')}
                  </span>
                ) : null}
              </div>
            </CardContent>
          </Card>
        ))}
        <IonInfiniteScroll
          ref={ionInfiniteScrollRef}
          onIonInfinite={loadMore}
          threshold="100px"
          disabled={!redeemedRewards.hasNextPage}
        >
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText="loading..."
          />
        </IonInfiniteScroll>
      </div>
    ) : (
      <div className="mx-auto max-w-md py-4">
        <Card>
          <CardContent>
            There are no redeemed rewards for this customer.
          </CardContent>
        </Card>
      </div>
    )
  }

  return <IonLoading isOpen message="Loading Redeemed Rewards..." />
}
export { CashierRedeemedRewardsDetail }
